import { render, staticRenderFns } from "./cm24-footer.vue?vue&type=template&id=66ba7edc&scoped=true"
import script from "./cm24-footer.vue?vue&type=script&lang=js"
export * from "./cm24-footer.vue?vue&type=script&lang=js"
import style0 from "./cm24-footer.vue?vue&type=style&index=0&id=66ba7edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba7edc",
  null
  
)

export default component.exports